import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import { imagePropTypes } from '../../Product.propTypes';

import * as Styled from './ProductImageZoom.styled';

export const centerWithinRef = (containerRef) => {
  const { scrollWidth, clientWidth } = containerRef.current;
  containerRef.current.scrollTo({ left: (scrollWidth - clientWidth) / 2 });
};

/**
 * A Modal to view high resolution product images
 */
const ProductImageZoom = ({ images, onRequestClose, isOpen, ...props }) => {
  const imageZoomRef = useRef(null);
  const handleOnLoad = useCallback(
    () => centerWithinRef(imageZoomRef),
    [imageZoomRef]
  );

  return (
    <Styled.Modal
      isFullscreen
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      withCollapse
      hasHeaderDivider={false}
      {...props}
    >
      <Styled.Button
        isRounded
        name="close"
        variant="default"
        colorMode="day"
        onClick={onRequestClose}
        disableRadiusAnimation
      >
        Close
      </Styled.Button>
      <Styled.ProductImageZoom ref={imageZoomRef}>
        {images.map((image) => (
          <Styled.Image
            key={image.id}
            src={image.src}
            alt={image.alt}
            resolution={{
              small: 1000,
              medium: 1400,
              large: 1500
            }}
            crop={{
              height: 3040,
              width: 3040
            }}
            background={convertColorToThemeHexCode('grey20')}
            onLowResLoad={handleOnLoad}
          />
        ))}
      </Styled.ProductImageZoom>
    </Styled.Modal>
  );
};

ProductImageZoom.propTypes = {
  /**
   * Array of image objects for the grid to display
   */
  images: PropTypes.arrayOf(PropTypes.shape(imagePropTypes)),
  /**
   * function to run when the modal is closed
   */
  onRequestClose: PropTypes.func,
  /**
   * `true` if the modal is open
   */
  isOpen: PropTypes.bool
};

ProductImageZoom.defaultProps = {
  images: [],
  onRequestClose: undefined,
  isOpen: false
};

export default ProductImageZoom;
